































































































import { Component, Vue } from 'vue-property-decorator';
import { NAMESPACE } from '@/store/models/work/enterprise/customers';
import { Getter, namespace } from 'vuex-class';
import { GET_ITEM, SHOW_REQUEST } from '@/store';
import CustomerItem from '@/components/work/customers/Item.vue';
import { GET_INVOICES, INVOICES_REQUEST } from '@/store/models/work/enterprise/invoices/outgoing';
import { Invoice } from '@/types/work/invoice';
import InvoiceItem from '@/components/work/invoices/item.vue';
import MapWayToPoint from '@/components/gMap/MapWayToPoint.vue';
import { CustomerModel } from '@/store/types/work/Providers';
import LogItem from '@/components/work/LogItem.vue';

const customerStore = namespace(NAMESPACE);

@Component({
  components: { LogItem, MapWayToPoint, CustomerItem, InvoiceItem }
})
export default class ShowCustomer extends Vue {
  @customerStore.Getter(GET_ITEM) customer!:CustomerModel;
  @customerStore.Action(SHOW_REQUEST) showRequest:any;

  @Getter(GET_INVOICES) invoices!: Invoice[];

  tab = 0;

  created () {
    this.showRequest(this.$route.params.customer);
    this.$store.dispatch(INVOICES_REQUEST, {
      filters: { provider_id: this.$route.params.customer },
      sort: [{ column: 'created_at', type: 'desc' }]
    });
    this.$gtag.event('page_view', {});
  }
}
